import { memo, useMemo } from 'react';

import { Phase } from '@/types/phase';
import Accordion from '@/ui/components/Accordion';
import DataList from '@/ui/components/DataList';
import DataRow from '@/ui/components/DataList/DataRow';
import DualTime from '@/ui/components/DualTime';
import snakeToTitleCase from '@/utils/snakeToTitleCase';

import { Props } from './types';

const Phases = ({ phases }: Props) => {
  const activePhases = useMemo(() => phases?.filter((phase) => phase.end_at === null), [phases]);
  const endedPhases = useMemo(() => phases?.filter((phase) => !!phase.end_at), [phases]);

  const renderPhase = (phase: Phase) => {
    const phaseTypeNameText = snakeToTitleCase(phase.phase_type.name);

    return (
      <>
        <DataRow label="Name">
          {phase.program != null
            ? `${phase.program?.name}, ${phaseTypeNameText}`
            : phaseTypeNameText}
        </DataRow>

        {phase.start_at && (
          <DataRow label="Start">
            <DualTime dateTime={new Date(phase.start_at)} />
          </DataRow>
        )}

        {phase.end_at && (
          <DataRow label="End">
            <span className="text-red-700">
              <DualTime dateTime={new Date(phase.end_at)} />
            </span>
          </DataRow>
        )}
      </>
    );
  };

  return (
    <>
      {activePhases?.map((phase, index) => {
        return (
          <DataList
            key={`${phase.phase_type.name}-${index}`}
            className="border border-gray-300 my-1 rounded-sm">
            {renderPhase(phase)}
          </DataList>
        );
      })}

      {endedPhases?.length > 0 && (
        <Accordion
          buttonText={`Show ${endedPhases.length} Ended ${endedPhases.length > 1 ? 'Phases' : 'Phase'}`}>
          <>
            {endedPhases?.map((phase, index) => {
              return (
                <DataList
                  key={`${phase.phase_type.name}-${index}`}
                  className="border border-gray-300 mb-1 rounded-sm">
                  {renderPhase(phase)}
                </DataList>
              );
            })}
          </>
        </Accordion>
      )}
    </>
  );
};

export default memo(Phases);
